
// Utils
// ---------------------------------------------
import { initComponents } from './lib/componentHelpers'
import { initModalLinks, initAnchorLinks } from './lib/linkHelpers'
import { PubSub } from './lib/PubSub'

// Components
// ---------------------------------------------
import {
  Accordion,
  AjaxForm,
  Bubbles,
  CardSlideshow,
  CookiePolicy,
  LoadImage,
  MobileNav,
  Modal,
  PageSlider,
  ReCaptcha,
  Slideshow,
  TabBox,
  VimeoVideo,
  YoutubeVideo
} from './components'

const APP = {}

APP.state = {
  isTransitioning: false
}

APP.events = new PubSub()

// Page Components
// <elem data-js-component="<component name>">
// ---------------------------------------------
APP.components = {
  Accordion,
  AjaxForm,
  Bubbles,
  CardSlideshow,
  CookiePolicy,
  LoadImage,
  MobileNav,
  Modal,
  PageSlider,
  ReCaptcha,
  Slideshow,
  TabBox,
  VimeoVideo,
  YoutubeVideo
}

APP.boot = (document, window) => {
  const modalWrapper = document.querySelector('.modal-wrapper')
  const siteWrapper = document.querySelector('.site-wrapper')
  initComponents(modalWrapper, APP)
  initComponents(siteWrapper, APP)
  initModalLinks(siteWrapper, modalWrapper, APP)
  initAnchorLinks(siteWrapper)
}

export default APP
